import { RowCrudStatus } from "../../common/types";
import {
  UserNotificationPreference,
  UserNotificationPreferenceCreateMutationVariables,
  UserNotificationPreferenceUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { NotificationType } from "../../../api/graphql";
import { EmailFrequency } from "../../../api/graphql";

export type UserNotificationPreferenceValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  notificationType: NotificationType;
  inAppEnabled: boolean;
  emailEnabled: boolean;
  emailFrequency: EmailFrequency;
};

export type UserNotificationPreferenceErrorsType = {
  notificationType?: { message: string; fieldLabel: string };
  inAppEnabled?: { message: string; fieldLabel: string };
  emailEnabled?: { message: string; fieldLabel: string };
  emailFrequency?: { message: string; fieldLabel: string };
};

export function UserNotificationPreferenceValuesInit(): UserNotificationPreferenceValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    notificationType: "" as NotificationType,
    inAppEnabled: false,
    emailEnabled: false,
    emailFrequency: "daily_digest" as EmailFrequency,
  };
}

export type UserNotificationPreferenceType =
  | UserNotificationPreference
  | UserNotificationPreferenceValuesType;

export function userNotificationPreferenceDisplayId(
  source: Partial<UserNotificationPreference>,
  _langStore: LangStore
) {
  return source.notificationType ?? _langStore.emptyStringSymbol;
}

export function getUserNotificationPreferenceValues(
  source: UserNotificationPreferenceType,
  _langStore: LangStore,
  _duplicated: boolean = false
): UserNotificationPreferenceValuesType {
  const entityValues = UserNotificationPreferenceValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : userNotificationPreferenceDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.notificationType = source.notificationType;
  entityValues.inAppEnabled = source.inAppEnabled || false;
  entityValues.emailEnabled = source.emailEnabled || false;
  entityValues.emailFrequency = source.emailFrequency;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getUserNotificationPreferenceUpdateVariables(
  values: UserNotificationPreferenceValuesType
): UserNotificationPreferenceUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    notificationType: values.notificationType,
    inAppEnabled: values.inAppEnabled,
    emailEnabled: values.emailEnabled,
    emailFrequency: values.emailFrequency,
  };
}

export function getUserNotificationPreferenceCreateVariables(
  values: UserNotificationPreferenceValuesType
): UserNotificationPreferenceCreateMutationVariables {
  return {
    notificationType: values.notificationType,
    inAppEnabled: values.inAppEnabled,
    emailEnabled: values.emailEnabled,
    emailFrequency: values.emailFrequency,
  };
}
